export default __webpack_public_path__ + "44ec4fa20aa0477edc4cb14a5a817246.png";